import { createContext } from 'react'

export const ButtonToneContext = createContext('default')
export const IconButtonToneContext = createContext('default')
